import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TagService } from './tag.service';
import { CropMetricsModel } from '../_models/cropMetrics';
import { XYearService } from './xYear.service';

@Injectable()
export class CropMetricsService {
  private http = inject(HttpClient);
  private tagService = inject(TagService);
  private xYearService = inject(XYearService);

  private apiBaseUrl = environment.apiBaseUrl;

  listCropMetrics = new BehaviorSubject<CropMetricsModel[]>([]);
  totFarm = new BehaviorSubject<number>(0);
  cropListSeeded = new BehaviorSubject<CropMetricsModel[]>([]);
  cropListHarvested = new BehaviorSubject<CropMetricsModel[]>([]);

  listCropMetrics$ = this.listCropMetrics.asObservable();
  totFarm$ = this.totFarm.asObservable();
  cropListSeeded$ = this.cropListSeeded.asObservable();
  cropListHarvested$ = this.cropListHarvested.asObservable();

  /**
   * Imperative method! - Call getCropMetrics manually with parameters
   */
  getCropMetrics(year?: number, avoidTags: boolean = false): Observable<CropMetricsModel[]> {
    const forceYear = year ?? this.xYearService.getYear();
    const tagQuery = avoidTags ? '' : this.tagService.getTagQuery();
    const url = `${this.apiBaseUrl}api/private/v1/cropMetrics?year=${forceYear}${tagQuery}`;

    return this.http
      .get<CropMetricsModel[]>(url)
      .pipe(tap((response) => this.handleResponse(response, forceYear)));
  }

  private handleResponse(response: CropMetricsModel[] | null, year: number): void {
    if (!response) {
      this.totFarm.next(0);
      this.listCropMetrics.next([]);
      this.cropListSeeded.next([]);
      this.cropListHarvested.next([]);
      return;
    }

    const totalFarm = response.find((el) => el.commodityName === 'total_farm');
    this.totFarm.next(totalFarm?.totFieldsSize ?? 0);

    const currentYearMetrics = response.filter((o) => o.year === year);
    this.listCropMetrics.next(currentYearMetrics);
    this.cropListSeeded.next(currentYearMetrics.filter((o) => o.seeded !== 0));
    this.cropListHarvested.next(currentYearMetrics.filter((o) => o.harvested !== 0));
  }
}
